var _module_exports = "<div data-ng-repeat=\"(key, value) in components\"><ec-schema component=\"value\"></ec-schema></div>";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/schema/schemas.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/schema/schemas.html
// module id = 915
// module chunks = 0